// extracted by mini-css-extract-plugin
export default {"button":"KeyBoard_button__MA1Q4"};